/* ═══════════════════════════════════════════════════════════
   ODENTIS — thème Shopify · comportements de la vitrine
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ───── Toast ───────────────────────────────────────────── */
  var toast = $('#toast'), toastMsg = $('#toastMsg'), tTimer = null;
  function say(msg) {
    if (!toast) return;
    if (msg) toastMsg.textContent = msg;
    toast.setAttribute('data-show', 'true');
    if (tTimer) clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.setAttribute('data-show', 'false'); }, 3600);
  }

  /* ───── Sous-navigation « Nos produits » ────────────────── */
  var header = $('#header');
  function bindMega() {
    var megaBtn = $('#megaBtn'), mega = $('#megaPanel');
    if (!megaBtn || !mega || !header) return;
    var t = null;
    function set(open) {
      mega.setAttribute('data-open', open ? 'true' : 'false');
      megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function open() { if (t) { clearTimeout(t); t = null; } set(true); }
    function close(delay) { if (t) clearTimeout(t); t = setTimeout(function () { set(false); t = null; }, delay === 0 ? 0 : (delay || 260)); }
    megaBtn.addEventListener('mouseenter', open);
    megaBtn.addEventListener('focus', open);
    megaBtn.addEventListener('mouseleave', function () { close(); });
    mega.addEventListener('mouseenter', open);
    mega.addEventListener('mouseleave', function () { close(); });
    header.addEventListener('focusout', function (e) { if (!header.contains(e.relatedTarget)) close(0); });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) close(0); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(0); });
  }
  bindMega();

  /* ───── En-tête collant ─────────────────────────────────── */
  if (header && header.getAttribute('data-sticky') === 'true') {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.setAttribute('data-scrolled', y > 8 ? 'true' : 'false');
      lastY = y;
    }, { passive: true });
  }

  /* ───── Voiles & tiroirs ────────────────────────────────── */
  var scrim = $('#scrim'), drawer = $('#drawer'), burger = $('#burger');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute('data-open', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) scrim.setAttribute('data-open', open ? 'true' : 'false');
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('is-locked', open);
    if (!open && burger) burger.focus();
  }
  if (burger) burger.addEventListener('click', function () { setDrawer(true); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#drawerClose')) setDrawer(false);
    if (drawer && e.target.closest && e.target.closest('#drawer a')) setDrawer(false);
  });

  function cartEl() { return $('#cart'); }
  function setCart(open) {
    var cart = cartEl();
    if (!cart) return;
    if (open) setDrawer(false);
    cart.setAttribute('data-open', open ? 'true' : 'false');
    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) scrim.setAttribute('data-open', open ? 'true' : 'false');
    root.classList.toggle('is-locked', open);
    if (open) { var c = $('#cartClose'); if (c) setTimeout(function () { c.focus(); }, 60); }
  }
  if (scrim) scrim.addEventListener('click', function () { setDrawer(false); setCart(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var cart = cartEl();
    if (cart && cart.getAttribute('data-open') === 'true') setCart(false);
    if (drawer && drawer.getAttribute('data-open') === 'true') setDrawer(false);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('#cartBtn') : null;
    if (btn && btn.getAttribute('data-cart-toggle') === 'drawer') { e.preventDefault(); setCart(true); }
    if (e.target.closest && e.target.closest('#cartClose')) setCart(false);
  });

  /* ───── Minuteur de réservation ─────────────────────────── */
  var tick = null;
  function runTimer() {
    var box = $('#ctimer');
    if (tick) { clearInterval(tick); tick = null; }
    if (!box) return;
    var mins = parseInt(box.getAttribute('data-minutes'), 10) || 10;
    var left = mins * 60;
    try {
      var saved = sessionStorage.getItem('odentis-reserve');
      if (saved) { var d = Math.floor((Date.now() - (+saved)) / 1000); left = Math.max(0, mins * 60 - d); }
      else sessionStorage.setItem('odentis-reserve', String(Date.now()));
    } catch (e) {}
    function mmss(s) { var m = Math.floor(s / 60), r = s % 60; return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r; }
    function paint() {
      var t = $('#ctimerT');
      if (!t) return;
      if (left > 0) { box.setAttribute('data-state', 'run'); t.innerHTML = 'Panier réservé <b>' + mmss(left) + '</b>'; }
      else { box.setAttribute('data-state', 'out'); t.innerHTML = '<b>Réservation expirée</b>'; }
    }
    paint();
    if (left > 0) tick = setInterval(function () { left -= 1; paint(); if (left <= 0) { clearInterval(tick); tick = null; } }, 1000);
    var ext = $('#ctimerB');
    if (ext) ext.addEventListener('click', function () {
      try { sessionStorage.setItem('odentis-reserve', String(Date.now())); } catch (e) {}
      runTimer();
    });
  }

  /* ───── Panier Ajax ─────────────────────────────────────── */
  function refreshCart(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#cart');
    var current = cartEl();
    if (fresh && current) {
      var wasOpen = current.getAttribute('data-open') === 'true';
      current.innerHTML = fresh.innerHTML;
      current.setAttribute('data-empty', fresh.getAttribute('data-empty'));
      current.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));
      if (wasOpen) current.setAttribute('data-open', 'true');
      var n = fresh.getAttribute('data-item-count') || '0';
      var bdg = $('#cartCount');
      if (bdg) { bdg.textContent = n; bdg.setAttribute('data-n', n); }
      runTimer();
    }
  }

  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.sections && data.sections['cart-drawer']) refreshCart(data.sections['cart-drawer']);
      return data;
    });
  }

  function addToCart(id, qty, feedbackBtn) {
    return cartRequest(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
      { items: [{ id: id, quantity: qty || 1 }] })
      .then(function (data) {
        if (data.status && data.description) { say(data.description); return; }
        say('Ajouté au panier');
        if (feedbackBtn) {
          var keep = feedbackBtn.innerHTML;
          feedbackBtn.classList.add('is-added');
          feedbackBtn.innerHTML = '<svg width="15" height="15" aria-hidden="true"><use href="#i-check"/></svg>Ajouté';
          setTimeout(function () { feedbackBtn.classList.remove('is-added'); feedbackBtn.innerHTML = keep; }, 1800);
        }
        if (document.body.getAttribute('data-cart-type') !== 'page') setCart(true);
      });
  }

  /* formulaires « ajouter » des cartes */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-ajax-add], form.pform')) return;
    e.preventDefault();
    var fd = new FormData(f);
    var id = fd.get('id');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var btn = f.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    addToCart(id, qty, btn).then(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  /* quantité et suppression dans le panier */
  document.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('[data-q]') : null;
    if (q && q.closest('#cart, [data-cart-page]')) {
      var line = parseInt(q.getAttribute('data-line'), 10);
      var item = q.closest('.citem');
      var cur = parseInt($('.cqty__v', item).textContent, 10) || 1;
      var next = Math.max(0, cur + parseInt(q.getAttribute('data-q'), 10));
      cartRequest('/cart/change.js', { line: line, quantity: next });
      return;
    }
    var rm = e.target.closest ? e.target.closest('[data-remove]') : null;
    if (rm) {
      cartRequest('/cart/change.js', { line: parseInt(rm.getAttribute('data-remove'), 10), quantity: 0 });
    }
  });

  runTimer();

  /* ───── Hero : produit mis en avant ─────────────────────── */
  (function () {
    var host = $('[data-hero-spotlight]');
    if (!host) return;
    var SPOT = json(host) || [];
    if (!SPOT.length) return;
    var dots = $$('.hero__dots button'), spot = $('#spot'), i = 0, timer = null;
    function paint(k) {
      var p = SPOT[k]; if (!p) return;
      spot.setAttribute('href', p.url);
      spot.setAttribute('aria-label', p.name + ', ' + p.price);
      $('#spotCat').textContent = p.cat || '';
      $('#spotName').textContent = p.name;
      $('#spotPrice').textContent = p.price;
      if (p.img) $('#spotArt').src = p.img;
      var c = $('#heroCounter'); if (c) c.textContent = (k + 1) + '/' + SPOT.length;
      dots.forEach(function (d, n) { if (n === k) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      i = k;
    }
    paint(0);
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        paint(parseInt(d.getAttribute('data-i'), 10));
        if (timer) { clearInterval(timer); timer = null; }
      });
    });
    var delay = (parseInt(spot.getAttribute('data-delay'), 10) || 5) * 1000;
    if (!reduce && spot.getAttribute('data-rotate') === 'true' && SPOT.length > 1) {
      timer = setInterval(function () { paint((i + 1) % SPOT.length); }, delay);
    }
  })();

  /* ───── Avis ────────────────────────────────────────────── */
  $$('[data-testimonials]').forEach(function (box) {
    var data = json($('[data-testimonial-data]', box)) || [];
    if (data.length < 2) return;
    var k = 0;
    function paint(n) {
      k = (n + data.length) % data.length;
      var q = data[k];
      $('#qText', box).innerHTML = q.t;
      $('#qName', box).textContent = q.n;
      $('#qRole', box).textContent = q.r;
      $('#qAv', box).textContent = q.a;
    }
    var p = $('#qPrev', box), n = $('#qNext', box);
    if (p) p.addEventListener('click', function () { paint(k - 1); });
    if (n) n.addEventListener('click', function () { paint(k + 1); });
  });

  /* ───── Page produit ────────────────────────────────────── */
  (function () {
    var gal = $('[data-gallery]');
    if (!gal) return;
    var main = $('#galMain'), thumbs = $$('.gal__t', gal);
    var media = json($('[data-gallery-media]', gal)) || [];

    function show(i) {
      if (!media[i] || !main) return;
      main.src = media[i].src;
      main.alt = media[i].alt || '';
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      gal.setAttribute('data-i', i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-i'), 10)); }); });

    if (gal.getAttribute('data-swipe') === 'true' && media.length > 1) {
      var x0 = null, y0 = null;
      var pane = $('.gal__main', gal);
      pane.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      pane.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy)) {
          var cur = parseInt(gal.getAttribute('data-i') || '0', 10);
          show((cur + (dx < 0 ? 1 : -1) + media.length) % media.length);
        }
        x0 = null;
      }, { passive: true });
    }

    /* variantes */
    var picker = $('[data-variant-picker]');
    if (picker) {
      var lbl0 = $('[data-add-label]');
      var ADD_LABEL = (lbl0 && lbl0.textContent.trim()) || 'Ajouter au panier';
      var SOLD_LABEL = (document.documentElement.lang === 'fr' ? 'Rupture' : 'Sold out');
      var variants = json($('[data-variant-data]', picker)) || [];
      var info = json($('[data-variant-info]', picker)) || {};
      var idInput = $('[data-variant-id]');
      function currentOptions() {
        return $$('[data-option-index]', picker).map(function (row) {
          var on = $('[aria-pressed="true"]', row);
          return on ? on.getAttribute('data-value') : null;
        });
      }
      function apply() {
        var sel = currentOptions();
        var match = variants.filter(function (v) {
          return sel.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];
        $$('[data-option-value]', picker).forEach(function (em, i) { em.textContent = sel[i] || ''; });
        if (!match) return;
        var meta = info[match.id] || {};
        if (idInput) idInput.value = match.id;

        var priceHost = $('[data-price-host]');
        if (priceHost) {
          var v = $('.v', priceHost);
          if (v && meta.price) v.textContent = meta.price;
          var was = $('.price__was', priceHost);
          if (was) {
            if (meta.compare) { was.textContent = meta.compare; was.hidden = false; }
            else was.hidden = true;
          }
        }
        var sku = $('[data-sku]'); if (sku) sku.textContent = meta.sku || '';

        var available = meta.available !== false;
        var addBtn = $('[data-add-button]'), lbl = $('[data-add-label]');
        if (addBtn) {
          if (available) { addBtn.removeAttribute('disabled'); if (lbl) lbl.textContent = ADD_LABEL; }
          else { addBtn.setAttribute('disabled', 'disabled'); if (lbl) lbl.textContent = SOLD_LABEL; }
        }
        var stock = $('.buy__stock'); if (stock) stock.setAttribute('data-in', available ? 'true' : 'false');
        var sp = $('[data-satc-price]'); if (sp && meta.price) sp.textContent = meta.price;

        if (meta.media) {
          for (var i = 0; i < media.length; i++) { if (media[i].id === meta.media) { show(i); break; } }
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      picker.addEventListener('click', function (e) {
        var b = e.target.closest('.sw, .opt__b');
        if (!b) return;
        var row = b.closest('[data-option-index]');
        $$('[aria-pressed]', row).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        apply();
      });
    }

    /* quantité */
    var qv = $('#qVal');
    if (qv) {
      var mi = $('#qMinus'), pl = $('#qPlus');
      if (mi) mi.addEventListener('click', function () { qv.value = Math.max(1, (+qv.value || 1) - 1); });
      if (pl) pl.addEventListener('click', function () { qv.value = Math.min(99, (+qv.value || 1) + 1); });
    }

    /* barre d'achat collante */
    var satc = $('#satc');
    if (satc && 'IntersectionObserver' in window) {
      var anchor = $('.buy__actions');
      if (anchor) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var on = !en.isIntersecting && en.boundingClientRect.top < 0;
            satc.setAttribute('data-on', on ? 'true' : 'false');
            satc.setAttribute('aria-hidden', on ? 'false' : 'true');
          });
        }, { threshold: 0 }).observe(anchor);
      }
      var sb = $('[data-satc-add]', satc);
      if (sb) sb.addEventListener('click', function () {
        var f = $('form.pform');
        if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  })();

  /* partage */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-share]') : null;
    if (!b) return;
    var url = b.getAttribute('data-share');
    if (navigator.share) navigator.share({ url: url });
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { say('Lien copié'); });
  });

  /* ───── Collection : filtres ────────────────────────────── */
  (function () {
    var form = $('[data-filter-form]');
    var sets = $('#fsets');
    if (!form || !sets) return;

    function submitFilters() {
      var params = [];
      $$('input[name]', form).forEach(function (inp) {
        if (inp.type === 'checkbox' && !inp.checked) return;
        if (inp.value === '' || inp.value == null) return;
        params.push(encodeURIComponent(inp.name) + '=' + encodeURIComponent(inp.value));
      });
      var sort = $('[data-sort-select]');
      if (sort && sort.value) params.push('sort_by=' + encodeURIComponent(sort.value));
      var base = window.location.pathname;
      window.location.href = params.length ? base + '?' + params.join('&') : base;
    }
    form.addEventListener('change', function (e) {
      if (e.target.type !== 'checkbox') return;
      var url = e.target.getAttribute('data-url');
      if (url) { window.location.href = url; return; }
      submitFilters();
    });
    $$('.prange input', form).forEach(function (inp) {
      inp.addEventListener('change', submitFilters);
    });
    var sortSel = $('[data-sort-select]');
    if (sortSel) sortSel.addEventListener('change', submitFilters);

    /* compteur de filtres actifs */

    /* relocalisation du bloc de filtres entre colonne et feuille mobile */
    var side = $('#fsideBody'), mob = $('#fmobBody');
    var mq = window.matchMedia('(max-width: 899px)');
    function place() {
      if (!side || !mob) return;
      if (mq.matches) { if (sets.parentElement !== mob) mob.appendChild(form); }
      else if (form.parentElement !== side) side.appendChild(form);
    }
    place();
    (mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place));

    /* feuille mobile */
    var fab = $('#filterBtn'), sheet = $('#fsheet'), fscrim = $('#fscrim');
    function setSheet(open) {
      if (!sheet) return;
      sheet.setAttribute('data-open', open ? 'true' : 'false');
      sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (fscrim) fscrim.setAttribute('data-open', open ? 'true' : 'false');
      if (fab) fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-locked', open);
    }
    if (fab) fab.addEventListener('click', function () { setSheet(true); });
    var cl = $('#fshClose'); if (cl) cl.addEventListener('click', function () { setSheet(false); });
    if (fscrim) fscrim.addEventListener('click', function () { setSheet(false); });
    var ap = $('#fshApply'); if (ap) ap.addEventListener('click', function () { setSheet(false); });

    /* ouverture par défaut des groupes sur mobile */
    if (mq.matches) $$('.fset', form).forEach(function (d) { d.open = true; });
  })();

  /* ───── Sommaire automatique des pages ──────────────────── */
  (function () {
    var host = $('[data-page-summary]'), nav = $('[data-page-nav]'), body = $('.lgl');
    if (!body) return;
    var heads = $$('h2', body);
    if (!heads.length) { if (host) host.hidden = true; if (nav) nav.hidden = true; return; }
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'sec-' + (i + 1) + '-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      h.closest('section') || (function () {
        /* enveloppe chaque titre dans un groupe pour le style */
        var grp = document.createElement('section');
        grp.className = 'lgrp';
        grp.id = h.id;
        h.parentNode.insertBefore(grp, h);
        var n = h;
        while (n && !(n !== h && n.tagName === 'H2')) { var next = n.nextSibling; grp.appendChild(n); n = next; if (n && n.tagName === 'H2') break; }
      })();
      if (host) {
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.innerHTML = h.textContent + '<span>' + (i < 9 ? '0' : '') + (i + 1) + '</span>';
        host.appendChild(a);
      }
      if (nav) {
        var b = document.createElement('a');
        b.href = '#' + h.id;
        b.textContent = h.textContent;
        nav.appendChild(b);
      }
    });
  })();

  /* ───── Formulaire de contact : sujet pré-rempli ────────── */
  (function () {
    var sel = $('[data-contact-subject]');
    if (!sel) return;
    var p = new URLSearchParams(window.location.search);
    var wanted = p.get('sujet');
    if (wanted) {
      var hit = $$('option', sel).filter(function (o) {
        return o.value.toLowerCase().indexOf(wanted.toLowerCase()) > -1 || o.textContent.toLowerCase().indexOf(wanted.toLowerCase()) > -1;
      })[0];
      if (hit) sel.value = hit.value;
    }
    var prod = p.get('produit');
    if (prod) {
      var msg = $('#cMsg');
      if (msg && !msg.value) msg.value = 'Bonjour,\n\nJe souhaite un prix pour : ' + prod + '.\n\n';
    }
  })();

  /* ───── Éditeur de thème ────────────────────────────────── */
  document.addEventListener('shopify:section:load', function () { bindMega(); runTimer(); });
})();
